// extracted by extract-css-chunks-webpack-plugin
module.exports = {"sellingFastBadge":"sellingFastBadge_fNgYy","productStockBanner":"productStockBanner_El278"};